"use client";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { productDetailsStore } from "@/store/pageModules";
import { FmCarousel } from "@/ui-component";
import { useProductDetailsContext } from "@/src/provider";
import { youTuBeVideoWH } from "@/lib/commonService";
import CarouselWrapper from "./CarouselWrapper";
import BannerShow, { getBannerShowData } from "./imgSwiperUtils";
import { useTranslation } from "react-i18next";
import SizeConversionCanvas, { ISizeConversionCanvasData } from "@/src/productDetails/SizeChart/SizeConversionCanvas";

interface IProps {
    colorId: number;
}
const CarouselSwiperClient: React.FC<React.PropsWithChildren<IProps>> = (
    props,
) => {
    // 监听activeobj的颜色切换状态，做对应更新
    const [currentColorId, setCurrentColorId] = useState(props.colorId);
    useEffect(() => setCurrentColorId(props.colorId), [props.colorId]);
    const [productDetail, activeObj, video] = useProductDetailsContext(
        (state) => [state.productDetail, state.activeObj, state.video],
    );
    const [t] = useTranslation(["common"]);
    const [isInches, setIsInches] = useState(false);
    const [swiperIndex, imgSrc, onChangeSwiperIndex, setVideoAndSizeImgIndex] =
        productDetailsStore.useProdcutDetailsStore((state) => [
            state.swiperIndex,
            state.imgSrc,
            state.onChangeSwiperIndex,
            state.setVideoAndSizeImgIndex,
        ]);

    const afterChange = useCallback(
        (current: number) => {
            onChangeSwiperIndex(current);
        },
        [onChangeSwiperIndex],
    );

    const videoAndSizeImg = useMemo(() => {
        //模特图，商品图
        let res = [];
        //加载尺寸图
        const imgRes = imgSrc.map(
            (item: ISizeConversionCanvasData, index: number) => {
                return (
                    <div
                        key={`imgsrc-${index}`}
                        className={"default_layout"}
                        style={{ width: "100%", height: "5rem" }}
                    >
                        <SizeConversionCanvas
                            canvasData={item}
                            isInches={isInches}
                            onChangeShowType={(isInches) =>
                                setIsInches(isInches)
                            }
                            backgroundColor="#f2f2f2"
                        />
                    </div>
                );
            },
        );

        //加载视频
        if (video) {
            res.push(
                <div
                    className={"default_layout"}
                    style={{ width: "100%", height: "5rem" }}
                >
                    <iframe
                        style={{
                            width: "100%",
                            height: "3.5rem",
                            marginBottom: "0.1rem",
                        }}
                        onLoad={(e) => {
                            youTuBeVideoWH(e.target, 750 / 432);
                        }}
                        src={`${video}?rel=0&loop=0`}
                        frameBorder="0"
                        allowFullScreen
                    />
                </div>,
            );
        }
        return [...imgRes, ...res];
    }, [imgSrc, isInches, video]);

    useEffect(() => {
        setVideoAndSizeImgIndex(videoAndSizeImg.length);
    }, [setVideoAndSizeImgIndex, videoAndSizeImg.length]);

    useEffect(() => {
        activeObj?.id && setCurrentColorId(activeObj?.id);
    }, [activeObj?.id]);

    const { list, productImgList } = useMemo(
        () => getBannerShowData(productDetail, activeObj, t),
        [activeObj, productDetail, t],
    );
    const imgList = useMemo(
        () =>
            // 颜色未被切换则使用服务端渲染的图片内容
            currentColorId === props.colorId
                ? []
                : list.map((item: string, index: number) => (
                      <BannerShow
                          key={`list-${currentColorId}-${index}`}
                          image={item}
                          index={index}
                          productImgListLength={productImgList.length}
                      />
                  )),
        [currentColorId, props.colorId, list, productImgList.length],
    );

    return (
        <FmCarousel
            infinite
            dots={false}
            onChangeIndex={afterChange}
            index={swiperIndex}
            style={{
                height: "6.26rem",
            }}
        >
            {!imgList.length
                ? props.children
                : imgList.map((item: any, index: number) => (
                      <CarouselWrapper key={index} index={index}>
                          {item}
                      </CarouselWrapper>
                  ))}
            {videoAndSizeImg.map((item, index) => (
                <CarouselWrapper key={index} index={index}>
                    {item}
                </CarouselWrapper>
            ))}
        </FmCarousel>
    );
};

export default CarouselSwiperClient;
